import { faUserHelmetSafety, faUserLarge, faUserNinja, faUserSecret } from '@fortawesome/pro-duotone-svg-icons';

import type { ExperienceLevelDetailsProps } from './experience-level.types';

export const experienceLevels: ExperienceLevelDetailsProps[] = [
  {
    icon: faUserLarge,
    hasContent: true,
    isDarkVersion: false,
    option: {
      label: 'Novice',
      name: 'experience-level',
      value: 'complete-beginner',
      content: 'I’m new to cyber security: I’m learning core concepts and basic security hygiene',
      disabled: false,
    },
  },
  {
    icon: faUserHelmetSafety,
    hasContent: true,
    isDarkVersion: false,
    option: {
      label: 'Apprentice',
      name: 'experience-level',
      value: 'early-intermediate',
      content: 'I run standard tools using tutorials to conduct basic scans and defenses',
      disabled: false,
    },
  },
  {
    icon: faUserNinja,
    hasContent: true,
    isDarkVersion: false,
    option: {
      label: 'Practitioner',
      name: 'experience-level',
      value: 'intermediate',
      content: 'I use industry tools to assess vulnerabilities and analyze logs for common threats',
      disabled: false,
    },
  },
  {
    icon: faUserSecret,
    hasContent: true,
    isDarkVersion: false,
    option: {
      label: 'Expert',
      name: 'experience-level',
      value: 'advanced',
      content: 'I develop tools and exploits, reverse-engineer binaries, and spot new vulnerabilities',
      disabled: false,
    },
  },
];
